<script setup>
import { reactive } from "vue";
// - LRR import { useMainStore } from "@/stores/main";
import {
  mdiAccount,
  mdiMail,
  mdiAsterisk,
  mdiFormTextboxPassword,
  mdiGithub,
} from "@mdi/js";
import SectionMain from "@/Components/SectionMain.vue";
import CardBox from "@/Components/CardBox.vue";
import BaseDivider from "@/Components/BaseDivider.vue";
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import FormFilePicker from "@/Components/FormFilePicker.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import UserCard from "@/Components/UserCard.vue";
//import LayoutAuthenticated from "@/layouts/LayoutAuthenticated.vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeButton from '@/Components/Button.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';

// LRR
const props = defineProps({
  object: Object,
  message: String
});

const data = {userName: 'Lenin', userEmail: 'lenin@leninrias.com', userAvatar: '../img/logo.png' }

// LRR
//const mainStore = useMainStore();
const mainStore = data;
//const mainStore = props.userData;
// Hola

/* const profileForm = reactive({
  name: mainStore.userName,
  email: mainStore.userEmail,
}); */

const profileForm = reactive({
  name: props.object ? props.object.name : '',
  email: props.object ? props.object.email : '',
});

//console.log(props.object)

const passwordForm = reactive({
  password_current: "",
  password: "",
  password_confirmation: "",
});

// LRR se  trajo de main store
const setUser = (payload) => {
  if (payload.name) {
    profileForm.userName = payload.name;
  }
  if (payload.email) {
    profileForm.userEmail = payload.email;
  }
  if (payload.avatar) {
    profileForm.userAvatar = payload.avatar;
  }
}

const submitProfile = () => {
  // - LRR mainStore.setUser(profileForm);
  //setUser(profileForm);
  let ruta = 'perfil-actualizar'
  Inertia.put(route(ruta, {
      //'id' : rowID.value,
      'name' : profileForm.name,
      'email' : profileForm.email
    }
  ))

};

const submitPass = () => {
  //
  let ruta = 'password-actualizar'
  Inertia.put(route(ruta, {
      //'id' : rowID.value,
      'password' : passwordForm.password,
      'password_confirmation' : passwordForm.password_confirmation
    }
  ))
};
</script>

<template>
  <Head title="Mi Perfil" />

  <BreezeAuthenticatedLayout>
    <SectionMain>
      <!--<template #header>
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Mi perfil
        </h2>
      </template>-->
      <SectionTitleLineWithButton :icon="mdiAccount" title="Mi perfil" main>
        <!-- <BaseButton
          href="https://github.com/justboil/admin-one-vue-tailwind"
          target="_blank"
          :icon="mdiGithub"
          label="Star on GitHub"
          color="contrast"
          rounded-full
          small
        /> -->
      </SectionTitleLineWithButton>

      <BreezeValidationErrors class="mb-4" />
      <div v-if="message">
        <!-- <div class="font-medium text-red-600">Ups! Algo está mal.</div> -->
        hol
        <ul class="mt-3 list-disc list-inside text-sm text-green-600">
            <!-- <li v-for="(error, key) in errors" :key="key">{{ error }}</li> -->
            <li>{{ message }}</li>
        </ul>
      </div>

      <!-- <UserCard class="mb-6" :userName="mainStore.userName" :avatarUrl="mainStore.userAvatar"/> -->

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CardBox is-form @submit.prevent="submitProfile">
          <!-- <FormField label="Avatar" help="Max 500kb">
            <FormFilePicker label="Upload" />
          </FormField> -->

          <FormField label="Nombre para mostrar" help="Nombre corto o Nickname">
            <FormControl
              v-model="profileForm.name"
              :icon="mdiAccount"
              name="username"
              required
              autocomplete="username"
            />
          </FormField>
          <FormField label="E-mail" help="Email de acceso al sistema">
            <FormControl
              v-model="profileForm.email"
              :icon="mdiMail"
              type="email"
              name="email"
              required
              autocomplete="email"
            />
          </FormField>

          <template #footer>
            <BaseButtons>
              <BaseButton color="info" type="submit" label="Guardar" />
              <!-- <BaseButton color="info" label="Options" outline /> -->
            </BaseButtons>
          </template>
        </CardBox>

        <CardBox is-form @submit.prevent="submitPass">
          <!-- <FormField
            label="Current password"
            help="Ingresar password actual"
          >
            <FormControl
              v-model="passwordForm.password_current"
              :icon="mdiAsterisk"
              name="password_current"
              type="password"
              required
              autocomplete="current-password"
            />
          </FormField>

          <BaseDivider /> -->

          <FormField label="Nuevo password" help="Ingresar nuevo password">
            <FormControl
              v-model="passwordForm.password"
              :icon="mdiFormTextboxPassword"
              name="password"
              type="password"
              required
              autocomplete="new-password"
            />
          </FormField>

          <FormField
            label="Confirmar password"
            help="Ingregar el nuevo password una vez más"
          >
            <FormControl
              v-model="passwordForm.password_confirmation"
              :icon="mdiFormTextboxPassword"
              name="password_confirmation"
              type="password"
              required
              autocomplete="new-password"
            />
          </FormField>

          <template #footer>
            <BaseButtons>
              <BaseButton type="submit" color="info" label="Guardar" />
              <!-- <BaseButton color="info" label="Options" outline /> -->
            </BaseButtons>
          </template>
        </CardBox>
      </div>
    </SectionMain>
  </BreezeAuthenticatedLayout>
</template>
